import { useEffect, useState, useTransition } from "react";
import {
    DefaultApi,
    StandardSearchResultList,
    NestedFaqTreeItem,
    Language
} from "../adapters/api";
import { useTranslation } from "react-i18next";

export const useTesting = (content: "test" | "tech") => {
    const defaultApi = new DefaultApi();
    const { t, i18n } = useTranslation();

    const [result, setResult] = useState<NestedFaqTreeItem[]>();

    const getTesting = async (): Promise<NestedFaqTreeItem[]> =>
        new Promise((resolve, reject) => {
            if (content === "test") {
                defaultApi
                    .getTesting(i18n.resolvedLanguage as Language)
                    .then((response) => {
                        const { data } = response;
                        setResult(data);
                        resolve(data);
                    })
                    .catch((e) => {
                        reject(e);
                    });
            }
            else if (content === "tech") {
                defaultApi
                    .getTechnology(i18n.resolvedLanguage as Language)
                    .then((response) => {
                        const { data } = response;
                        setResult(data);
                        resolve(data);
                    })
                    .catch((e) => {
                        reject(e);
                    });
            }
        });

    useEffect(() => {
        getTesting();
        // eslint-disable-next-line
    }, [t]);

    return {
        result,
    };
}

export const useTestingStandardSearch = (query: string) => {
    const defaultApi = new DefaultApi();

    const [result, setResult] = useState<StandardSearchResultList>();

    const getStandardSearch = async (
        queryString: string
    ): Promise<StandardSearchResultList> =>
        new Promise((resolve, reject) => {
            defaultApi
                .getStandards(queryString)
                .then((response) => {
                    const { data } = response;
                    setResult(data);
                    resolve(data);
                })
                .catch((e) => {
                    reject(e);
                });
        });

    useEffect(() => {
        getStandardSearch(query);
        // eslint-disable-next-line
    }, []);

    return {
        result,
    };
};
